import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageCourseBundles() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addBundle(data) {
    return privateFetch.post(`/v1/admin/courses/bundles`, data);
  }

  function updateBundle({ id: bundleID, ...rest } = {}) {
    return privateFetch.put(`/v1/admin/courses/bundles/${bundleID}`, rest);
  }

  function deleteBundle({ id: bundleID, ...rest } = {}) {
    return privateFetch.delete(`/v1/admin/courses/bundles/${bundleID}`, rest);
  }

  function managePlan({ type, ...data }) {
    if (type === 'UPDATE') return updateBundle(data);
    if (type === 'DELETE') return deleteBundle(data);

    return addBundle(data);
  }

  return useMutation(managePlan, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('course-bundles');
    },
  });
}

export default useManageCourseBundles;
